import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProgramTemplateSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-header {
    padding-left: 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
    ${responsive.MOBILE`
        justify-content: space-between;
        align-items: center;
    `};
  }
  .form-container {
    padding: 0px 0px 16px 16px;

    ${responsive.MOBILE`
      margin-top: 0px;
      padding: 0px 8px 16px 8px;
    `}
  }

  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    ${responsive.MOBILE`
        flex-direction:column-reverse;
        padding: 16px 8px 16px 8px !important;
        padding-bottom: 0px !important;
        margin-top: 0px !important;
        margin-right: 0px !important;
        padding-bottom: 16px !important;
      `}
    button {
      margin-right: 16px;
      ${responsive.MOBILE`
        width:100%;
        margin:0px 
      `}
    }
  }
  .MuiGrid2-root {
    padding-right: 16px;
    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
    ${responsive.MOBILE`
      padding-left: 8px;
      padding-right: 8px;
    `}
  }

  .confirm-message {
    line-height: 20px;
    margin-bottom: 8px;
    color: ${COLORS.cirrus_black10};
  }

  .item-name {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .reset-all-button {
    margin-right: 16px;
    ${responsive.MOBILE`
      margin-right: 0px;
    `}
  }
`;
